export default {
    'locale.de': 'German',
    'locale.en': 'English',
    'login.title': 'Login',
    'login.label.email': 'Email',
    'login.label.password': 'Password',
    'login.btn.submit': 'Login now',
    'navigation.home': 'Start',
    'navigation.videos': 'My Videos',
    'navigation.projects': 'My Projects',
    'navigation.faq': 'FAQ',
    'navigation.imprint': 'Imprint',
    'navigation.legal': 'Terms',
    'navigation.privacy': 'Privacy Policy',
    'navigation.logout': 'Logout',
    'imprint.text': require('./texts/en/imprint').default,
    'imprint.title': 'Imprint',
    'legal.text': require('./texts/en/legal').default,
    'legal.title': 'Terms',
    'privacy.text': require('./texts/en/privacy').default,
    'privacy.title': 'Privacy Policy',
    'faq.title': 'FAQ',
    'page404.text': require('./texts/en/page404').default,
    'page404.title': 'Page not found',
    'code.text': require('./texts/en/code').default,
    'project.instruction.buttons.redo': 'Repeat take',
    'project.instruction.buttons.repeat': 'Additional take',
    'project.instruction.buttons.skip': 'Skip',
};
